var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#717070;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.6,9.1h-53c-5.7,0-10.4,4.6-10.4,10.4v34c0,5.7,4.6,10.4,10.4,10.4h53c5.7,0,10.4-4.6,10.4-10.4v-34 C86,13.8,81.3,9.1,75.6,9.1z M48.2,37.9L22,14.6l0.7-0.1l52.8,0l0.7,0.1L48.2,37.9z M80.6,53.5c0,2.7-2.2,5-5,5h-53 c-2.7,0-5-2.2-5-5v-34c0-0.4,0.1-0.9,0.2-1.3l28.6,25.4c1,0.9,2.5,0.9,3.5,0l30.5-25.4c0.1,0.4,0.2,0.9,0.2,1.3L80.6,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,70.4c-1.5,0-2.7,1.2-2.7,2.7v6.8c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7V73 C51.8,71.6,50.6,70.4,49.1,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,70.4c-1.5,0-2.7,1.2-2.7,2.7v17.5c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7V73 C65.2,71.6,64,70.4,62.5,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.7,70.4c-1.5,0-2.7,1.2-2.7,2.7v17.5c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7V73 C38.4,71.6,37.2,70.4,35.7,70.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.764152018ec309994300c34d5d889300.svg";
export { ForwardRef as ReactComponent };